import { useState } from "react";

export default function SortOptions({ onChange }) {
  const [selected, setSelected] = useState("Popular");

  const options = [
    "Popular",
    "User Rating (Highest First)",
    "Price (Highest First)",
    "Price (Lowest First)",
  ];

  const handleSelect = (option) => {
    setSelected(option);
    onChange?.(option);
  };

  return (
    <div className="flex items-center gap-4 text-sm pb-2 mb-2">
      <span className="font-medium">Sort By :</span>
      {options.map((option, index) => (
        <div key={option} className="flex items-center">
          <button
            onClick={() => handleSelect(option)}
            className={`hover:text-primary transition-colors font-medium ${
              selected === option ? "text-primary font-semibold" : ""
            }`}
          >
            {option}
          </button>
          {index < options.length - 1 && (
            <span className=" bg-black/20 block w-[0.5px] h-[12px] ml-4"></span>
          )}
        </div>
      ))}
    </div>
  );
}
